module.exports = __webpack_public_path__ + "img/hero-mobile_cn.6990b96.jpg";